import { PlusCircleIcon } from '@heroicons/react/outline';
import Popup from '../Low Level/Popup';
import React, { useEffect, useState } from 'react';
import NewTransferPopupBody from '../Low Level/NewTransferPopupBody';

const Bank = ({ user, citizenID, database, getTime, getDate, getYear }) => {
  const [newTransferPopupOpen, setNewTransferPopupOpen] = useState(false);
  const [westers, setWesters] = useState('...');
  const [bankAccounts, setBankAccounts] = useState([]);

  function censor(id) {
    return id.startsWith('CI-') && user.citizenID != id
      ? `CI-***${id.substring(6, 8)}`
      : id;
  }

  console.log('from bank', newTransferPopupOpen);

  return (
    <div className='mx-1 lg:mx-10 my-1 lg:my-5'>
      <div className='flow-root py-2'>
        <div className='float-left'>
          <p className='text-4xl text-white font-bold'>Bank</p>
        </div>

        <div className='float-right'>
          <button
            className='rounded-full px-3 py-2 bg-sky-400 font-semibold hover:bg-sky-500 flex shadow'
            onClick={() => {
              console.log('buh?');
              setNewTransferPopupOpen(true);
            }}
          >
            <PlusCircleIcon className='w-6 h-6' />
            <p className='pl-1 text-black'>Send Money</p>
          </button>
          <Popup
            open={newTransferPopupOpen}
            setOpen={setNewTransferPopupOpen}
            header='New Transfer'
            onClickSave={() => {}}
            inputs={[]}
            saveText={'Send'}
            additionalComponent={() => {
              return (
                <NewTransferPopupBody
                  database={database}
                  bankAccounts={bankAccounts}
                  user={user}
                  setWesters={setWesters}
                  westers={westers}
                  getTime={getTime}
                  getDate={getDate}
                  getYear={getYear}
                  setNewTransferPopupOpen={setNewTransferPopupOpen}
                />
              );
            }}
          />
        </div>
      </div>
      <div className='p-2 lg:p-6 group bg-gray-800 rounded'>
        <div className='lg:flow-root w-full  p-1 shadow bg-gray-700 border-4 border-gray-500 text-bottom'>
          <div className='lg:float-left text-bottom '>
            <p className='text-2xl font-semibold pl-1 text-gray-200'>
              Current Balance
            </p>
          </div>
          <div className='flex justify-center text-2xl font-bold lg:float-right px-1 border-2 border-gray-500 bg-black'>
            <p className='px-1'>W{user.westers}</p>
          </div>
        </div>

        <div className='w-full border-gray-500 border-b-4 border-r-4 border-l-4 bg-gray-700'>
          <p className='font-semibold text-gray-200 px-2 pt-2 text-xl'>
            Transaction History
          </p>
          {user.transfers != undefined &&
          Object.values(user.transfers).length != 0 ? (
            <div className='lg:p-2 p-1 bg-gray-800'>
              {Object.values(user.transfers)
                .sort((transfer1, transfer2) => {
                  return transfer2.mssce - transfer1.mssce;
                })
                .map((transfer) => {
                  return (
                    <div className='p-1'>
                      <Transfer transfer={transfer} />
                    </div>
                  );
                })}
            </div>
          ) : (
            <div className='p-2 bg-gray-800'>
              <p className='font-bold text-2xl'>Nothing yet</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  function Transfer({ transfer }) {
    return (
      <div className='border border-gray-400 bg-gray-800 shadow'>
        <div className='w-full lg:flow-root border-b border-gray-400 bg-gray-00'>
          <p className='lg:float-left pl-2 py-2 font-semibold text-gray-200'>
            {transfer.date} at {transfer.time}
          </p>
          <p className='lg:float-right lg:pl-0 pl-2 pr-2 py-2 font-semibold text-gray-200'>
            {transfer.transferID} {transfer.mssce}
          </p>
        </div>
        <div className='grid grid-cols-4 lg:gap-3 gap-y-3 p-2'>
          {transfer.type == 'Incoming' ? (
            <div className='col-span-4 lg:col-span-2 grid grid-cols-2'>
              <div className='col-span-1'>
                <p className='font-semibold'>Amount</p>
                <p className='text-green-500'>+W{transfer.amount}</p>
              </div>
              <div className='col-span-1'>
                <p className='font-semibold'>Sender</p>
                <p className=''>{transfer.senderName}</p>
                <p className=''>
                  {transfer.senderName !=
                    'Charlington Establishment and Zard' &&
                  transfer.senderName != 'Charlington National Bank' &&
                  transfer.senderName != 'Stock Market' &&
                  transfer.senderName != 'Charlington Government'
                    ? censor(transfer.senderID)
                    : ''}
                </p>
              </div>
            </div>
          ) : (
            <div className='col-span-4 lg:col-span-2 grid grid-cols-2'>
              <div className='col-span-1'>
                <p className='font-semibold'>Amount</p>
                <p className='text-red-500'>-W{transfer.amount}</p>
              </div>
              <div className='col-span-1'>
                <p className='font-semibold'>Receiver</p>
                <p className=''>{transfer.receiverName}</p>
                <p className=''>
                  {transfer.receiverName !=
                    'Charlington Establishment and Zard' &&
                  transfer.receiverName != 'Charlington National Bank' &&
                  transfer.receiverName != 'Real Currency' &&
                  transfer.receiverName != 'Stock Market' &&
                  transfer.receiverName != 'Charlington Government'
                    ? censor(transfer.receiverID)
                    : ''}
                </p>
              </div>
            </div>
          )}
          <div className='col-span-2 lg:col-span-1'>
            <p className='font-semibold'>Reason</p>
            <p className=''>{transfer.reason}</p>
          </div>
          <div className='col-span-2 lg:col-span-1'>
            <p className='font-semibold'>Resulting Balance</p>
            <p className=''>W{transfer.resultingBalance}</p>
          </div>
        </div>
      </div>
    );
  }
};

export default Bank;
